import React from 'react';

import { PendingCardStatus, PendingCardTokenForUI } from '@/domain/digital-wallet';
import PendingCardTokenItem from '@/widgets/PendingCardTokens/PendingCardTokenItem';

import { getStatusForCardTokenUI } from '@domain/digital-wallet/utils/pending-cards-mapper';

import './PendingCardTokenList.scss';

type Props = {
    pendingCards: PendingCardTokenForUI[];
    statusArray: PendingCardStatus[];
    activateCard: (cardId: string) => void;
    title: string;
    show: boolean;
    cardInfoLoading: boolean;
};

const PendingCardTokenList: React.FC<Props> = ({
    pendingCards,
    statusArray,
    activateCard,
    title,
    show,
    cardInfoLoading,
}) => {
    if (!show) return null;
    return (
        <section className="pending-card-list__wrapper" data-testid="pending-cards-list">
            <span className="pending-card-list__title typography-subtitle">{title}</span>
            <ul className="pending-card-list">
                {pendingCards?.map((pendingCard) => (
                    <PendingCardTokenItem
                        cardInfoLoading={cardInfoLoading}
                        key={pendingCard.cardId}
                        status={getStatusForCardTokenUI(pendingCard, statusArray)}
                        pendingCardToken={pendingCard}
                        activateCardToken={activateCard}
                    />
                ))}
            </ul>
        </section>
    );
};

export default PendingCardTokenList;
